import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
} from "../../../components/card/card";
import ImageViewer from "../../../components/ImageViewer";
import { printDate, printLocation } from "../../../utils/helper";
import React, { useState, useEffect } from "react";
import { user as userAPI, notificationGroup } from "../../../api";
import { parserAPI } from "../../../utils/parser";
import { useQuery } from "@tanstack/react-query";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import NormalInput from "../../../components/form/HorizontalNormalInput";

import ConfirmationDlg from "../../../components/ConfirmationDlg";
import Select, { StylesConfig } from "react-select";
import { Form } from "react-bootstrap";
import NormalSelect from "../../../components/form/HorizontalNormalSelect";

const colourStyles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "#0000007a",
    zIndex: 999999,
  }),
  input: (styles) => ({
    ...styles,
    color: "white",
    zIndex: 999999,
  }),
  menu: (styles) => ({
    ...styles,
    color: "grey",
    zIndex: 99999999999999999,
    opacity: 1,
  }),
};

const defaultNotificationSelecttions = [
  {
    name: "high_vibration_alert",
    active: false,
    email: false,
    whatsapp: false,
    frequency: {
      total: 1,
      type: "day",
      sent_at: [],
    },
    sequential: "",
  },
  {
    name: "high_temperature_alert",
    active: false,
    email: false,
    whatsapp: false,
    frequency: {
      total: 1,
      type: "day",
      sent_at: [],
    },
    sequential: "",
  },
  {
    name: "alarm_reminder",
    active: false,
    email: false,
    whatsapp: false,
    frequency: {
      total: 1,
      type: "day",
      sent_at: [],
    },
    sequential: "",
  },
  {
    name: "urgent_alarm",
    active: false,
    email: false,
    whatsapp: false,
    frequency: {
      total: 1,
      type: "day",
      sent_at: [],
    },
    sequential: "",
  },
  {
    name: "offline_alert",
    active: false,
    email: false,
    whatsapp: false,
    frequency: {
      total: 1,
      type: "day",
      sent_at: [],
    },
    sequential: "",
  },
];

function NotificationHierarchyConfiguration() {
  const [openDetail, setOpenDetail] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const [confirmDlg, setConfirmDlg] = useState(false);
  const [openModalTeam, setOpenModalTeam] = useState(false);
  const [teamName, setTeamName] = useState("");
  const [member, setMember] = useState([]);
  const [users, setUsers] = useState([]);
  const [teams, setTeams] = useState([]);
  const [allTeams, setAllTeams] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [deleteRow, setDeleteRow] = useState(null);
  const [query, setQuery] = useState({ page: 1, take: 10, totalData: 1 });
  const [loading, setLoading] = useState(false);
  const [notificationSelections, setNotificationSelections] = useState(
    defaultNotificationSelecttions
  );

  async function getUser() {
    try {
      const res = await userAPI.list();
      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        if (data.length) {
          let tmp = [];
          data.map((i, index) => {
            let item = i;
            item.id = index + 1;
            tmp.push(item);
          });
          setUsers(tmp);
          setIsDirty(false);
        }
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }

  async function getTeam() {
    try {
      setLoading(true);
      const res = await notificationGroup.list(query);
      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        if (data.results) {
          setTeams(data.results);
          setIsDirty(false);
        } else {
          setTeams([]);
          setIsDirty(false);
        }

        if (data.totalData) {
          setQuery((prev) => ({
            ...prev,
            totalData: data.totalData,
          }));
        }
        setLoading(false);
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }

  async function getAllTeam() {
    try {
      const res = await notificationGroup.list();
      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        if (data) {
          setAllTeams(data);
        } else {
          setAllTeams([]);
        }
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }

  useEffect(() => {
    getUser();
    getTeam();
  }, [query.page, query.take, isDirty]);

  function selectUser(value) {
    //console.log("selected machine", value);
  }
  function addUser(value) {
    getAllTeam();
    setSelectedRow(null);
    setOpenModalTeam(true);
    setTeamName("");
    setMember([]);
    setNotificationSelections(defaultNotificationSelecttions);
  }
  function editUser(value) {
    getAllTeam();
    setSelectedRow(value);
    setOpenModalTeam(true);
    setTeamName(value.group_name);
    setMember(
      value.members.map((member) => ({
        value: member.user.username,
        label: member.user.firstname + " " + member.user.lastname,
      }))
    );

    let config = value.configurations;
    // check from default configuration  that not exist in config
    const defaultConfigNotExist = [];
    defaultNotificationSelecttions.map((d) => {
      const existingConfig = config.find((c) => c.name === d.name);
      if (!existingConfig) defaultConfigNotExist.push(d);
    });
    console.log({ defaultConfigNotExist, config });
    // add defaultConfigNotExist to config
    config = [...config, ...defaultConfigNotExist];

    setNotificationSelections(config);
  }

  function showConfirmationDlg(row) {
    setDeleteRow(row);
    setConfirmDlg(true);
  }
  function hideConfirmationDialog() {
    setDeleteRow(null);
    setConfirmDlg(false);
  }

  async function deleteUser() {
    try {
      const res = await notificationGroup.delete(deleteRow.id);
      if (res.ok) {
        toast.success("This team has been deleted");
        setConfirmDlg(false);
        setDeleteRow(null);
        const body = await res.json();
        setIsDirty(true);
        await getTeam();
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }
  const columns = [
    {
      name: "Group Name",
      selector: (row) => row.group_name,
    },
    {
      name: "Total Users",
      minWidth: "200px",
      style: {
        paddingRight: "0",
      },
      cell: (row) => {
        return <span>{row.members?.length}</span>;
      },
    },
    {
      name: "Action",
      width: "150px",
      style: {
        paddingRight: "0",
      },
      cell: (row) => {
        return (
          <div>
            <button
              onClick={() => {
                editUser(row);
              }}
              className="btn btn-sm btn-outline-theme mx-1"
            >
              <i className="fa fa-edit"></i>
            </button>
            <button
              onClick={() => {
                showConfirmationDlg(row);
              }}
              className="btn btn-sm btn-outline-danger"
            >
              <i className="fa fa-trash"></i>
            </button>
          </div>
        );
      },
    },
  ];

  const handleChange = (e, name, type) => {
    const copy = [...notificationSelections];
    const index = copy.findIndex((c) => c.name == name);
    if (!type) {
      copy[index].active = e.target.checked;
    } else {
      copy[index][type] = e.target.checked;
    }

    setNotificationSelections(copy);
  };
  const handleChangeFrequency = (e, name) => {
    const key = e.target.name;
    const value = e.target.value;
    const copy = [...notificationSelections];
    const index = copy.findIndex((c) => c.name == name);
    copy[index].frequency[key] = value;
    if (key == "type") copy[index].frequency.sent_at = [];
    setNotificationSelections(copy);
  };

  const handleChangeSentAt = (e, name) => {
    const value = e;
    const copy = [...notificationSelections];
    const index = copy.findIndex((c) => c.name == name);
    copy[index].frequency.sent_at = value;
    setNotificationSelections(copy);
  };
  const handleChangeSequential = (e, name) => {
    const value = e.target.value;
    const copy = [...notificationSelections];
    const index = copy.findIndex((c) => c.name == name);
    copy[index].sequential = value;
    setNotificationSelections(copy);
  };

  async function onSubmitTeam() {
    const arr = member.map((i) => {
      return i.value;
    });
    let data = {
      group_name: teamName,
      members: arr,
      configurations: notificationSelections,
    };
    console.log({ data });
    if (!selectedRow) {
      const response = await notificationGroup.create2(data);
      if (response.ok) {
        const body = await response.json();
        //console.log({ body });
        if (body.success) {
          //toast.success(body.message);
          toast.success("Team " + teamName + " is successfully added");
          setSelectedRow(null);
          setOpenModalTeam(false);
          setIsDirty(true);
          await getTeam();
        } else {
          toast.error(body.message);
        }
      } else {
        toast.error("API Error");
      }
    } else {
      const response = await notificationGroup.update(selectedRow.id, data);
      if (response.ok) {
        const body = await response.json();
        //console.log({ body });
        if (body.success) {
          //toast.success(body.message);
          toast.success("Team " + teamName + " is successfully updated");
          setSelectedRow(null);
          setOpenModalTeam(false);
          setIsDirty(true);
          await getTeam();
        } else {
          toast.error(body.message);
        }
      } else {
        toast.error("API Error");
      }
    }
  }

  return (
    <div>
      <ConfirmationDlg
        open={openModalTeam}
        onSubmit={onSubmitTeam}
        btnSubmitText={"Save"}
        title={"Add Group"}
        btnCancelText={"Cancel"}
        onClose={() => {
          setOpenModalTeam(false);
        }}
        size="lg"
      >
        <NormalInput
          required={true}
          value={teamName}
          type={"text"}
          label="Group Name"
          onchange={(e) => {
            setTeamName(e.target.value);
          }}
          name="teamName"
        />
        <div>
          <p>Notification Selection</p>
          {notificationSelections.map((ns, i) => (
            <div
              style={{ border: "1px solid #ffffff40" }}
              key={i}
              className="mb-4"
            >
              <CardHeader>
                <Form.Check
                  style={{ textTransform: "capitalize" }}
                  type={"checkbox"}
                  label={ns.name.replaceAll("_", " ")}
                  checked={ns.active}
                  onChange={(e) => handleChange(e, ns.name)}
                />
              </CardHeader>

              {ns.active && (
                <CardBody>
                  <div className="row">
                    <div className="col-md-3">
                      <Form.Check
                        style={{ textTransform: "capitalize" }}
                        type={"checkbox"}
                        label={"Email"}
                        checked={ns.email}
                        onChange={(e) => handleChange(e, ns.name, "email")}
                      />
                    </div>

                    <div className="col-md-3">
                      <Form.Check
                        style={{ textTransform: "capitalize" }}
                        type={"checkbox"}
                        label={"WhatsApp"}
                        checked={ns.whatsapp}
                        onChange={(e) => handleChange(e, ns.name, "whatsapp")}
                      />
                    </div>
                    <div className="col-md-12">
                      <hr></hr>
                    </div>
                    <div className="col-md-12">
                      <div className="row align-items-center">
                        <div className="col-md-5">
                          <NormalInput
                            label={"Total Notification per day"}
                            type="number"
                            name="total"
                            min={1}
                            value={ns.frequency.total}
                            onchange={(e) => handleChangeFrequency(e, ns.name)}
                          />
                        </div>

                        <div className="col-md-3">
                          <NormalSelect
                            value={ns.frequency.type}
                            label={"Type"}
                            name="type"
                            valueKey={"value"}
                            onchange={(e) => handleChangeFrequency(e, ns.name)}
                            list={[
                              {
                                name: "Day",
                                value: "day",
                              },
                              {
                                name: "Week",
                                value: "week",
                              },
                              {
                                name: "Month",
                                value: "month",
                              },
                            ]}
                          />
                        </div>

                        {ns.frequency.type == "week" && (
                          <div className="col-md-12">
                            <Select
                              isMulti
                              placeholder="Select Day"
                              styles={colourStyles}
                              options={[
                                {
                                  label: "Monday",
                                  value: 1,
                                },
                                {
                                  label: "Tuesday",
                                  value: 2,
                                },
                                {
                                  label: "Wednesday",
                                  value: 3,
                                },
                                {
                                  label: "Thursday",
                                  value: 4,
                                },
                                {
                                  label: "Friday",
                                  value: 5,
                                },
                                {
                                  label: "Saturday",
                                  value: 6,
                                },
                                {
                                  label: "Sunday",
                                  value: 7,
                                },
                              ]}
                              value={ns.frequency.sent_at}
                              onChange={(e) => {
                                handleChangeSentAt(e, ns.name);
                              }}
                            />
                          </div>
                        )}

                        {ns.frequency.type == "month" && (
                          <div className="col-md-12">
                            <Select
                              isMulti
                              placeholder="Select Date"
                              styles={colourStyles}
                              options={[...Array(30)].map((_, i) => ({
                                label: i + 1,
                                value: i + 1,
                              }))}
                              value={ns.frequency.sent_at}
                              onChange={(e) => {
                                handleChangeSentAt(e, ns.name);
                              }}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-md-12">
                      <hr></hr>
                    </div>

                    <div className="col-md-12">
                      <NormalSelect
                        additionalInformation="Applying Sequential means that this notification hierarchy group will get a notification after the selected group has received their notifications, in a sequential order."
                        valueKey={"value"}
                        label={"Apply Sequential"}
                        value={ns.sequential}
                        onchange={(e) => handleChangeSequential(e, ns.name)}
                        list={allTeams.map((t) => ({
                          name: t.group_name,
                          value: t.id,
                        }))}
                      />
                    </div>
                  </div>
                </CardBody>
              )}
            </div>
          ))}
        </div>
        <div className="mb-3 force-transparent" style={{ zIndex: 9999999 }}>
          <label className="form-label">Users</label>
          <Select
            isMulti
            styles={colourStyles}
            options={users.map((i) => {
              return {
                value: i.username,
                label: i.firstname + " " + i.lastname,
              };
            })}
            value={member}
            onChange={(e) => {
              setMember(e);
            }}
          />
        </div>
      </ConfirmationDlg>
      <ConfirmationDlg
        open={confirmDlg}
        onClose={() => {
          setConfirmDlg(false);
          setDeleteRow(null);
        }}
        onSubmit={deleteUser}
      >
        <div>Are you sure you want to delete this Group?</div>
      </ConfirmationDlg>
      <div className="d-flex align-items-center mb-3">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#/">Configuration</a>
            </li>
            <li className="breadcrumb-item active">Notification Hierarchy</li>
          </ol>
          <h1 className="page-header mb-0">Notification Hierarchy</h1>
        </div>
      </div>

      <div className="row gx-4">
        <div className="col-lg-12 ">
          <div className="row justify-content-end">
            <div className="col-sm-3 mb-2 mb-sm-0">
              <button onClick={addUser} className="btn btn-outline-theme w-100">
                Add Hierarchy Group <i className="bi bi-plus"></i>
              </button>
            </div>
          </div>
          <Card className="mb-4 mt-2">
            <CardHeader>List Hierarchy Group</CardHeader>
            <CardBody>
              <DataTable
                progressPending={loading}
                pointerOnHover
                onRowClicked={(row) => {
                  editUser(row);
                }}
                highlightOnHover
                theme="dark"
                columns={columns}
                data={teams}
                pagination
                paginationServer
                onChangeRowsPerPage={(row) =>
                  setQuery((prev) => ({ ...prev, page: 1, take: row }))
                }
                paginationTotalRows={query.totalData}
                onChangePage={(page) =>
                  setQuery((prev) => ({ ...prev, page: page }))
                }
              />
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
}
export default NotificationHierarchyConfiguration;
